import api from "./api";

/* Log a WhatsApp tap (customer→agent, agent→customer, admin→anyone) so the admin can see who contacted whom. Never blocks the tap. */
export const logWa = (target = {}, context = "") => { api.post("/wa-contact", { ...target, context }).catch(() => {}); };

export const waHref = (mobile, text = "") => { const d = String(mobile || "").replace(/\D/g, "").slice(-10); return `https://wa.me/${d ? "91" + d : ""}?text=${encodeURIComponent(text)}`; };
